export default "/build/images/aero-score-c.30350b89.png";